import "core-js/modules/es7.object.get-own-property-descriptors";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../../../SelectInput/index";
import AddInput from "../../../AddInput/index";
import networkInfo from "../../../networkInfo/index";
import { updateConfig as _updateConfig, listConfig, getNetworkInfo } from '@/api/configurationlist';
import { cloneDeep, isEqual } from 'lodash';
export default {
  props: ["deviceDid", "deviceSn"],
  data: function data() {
    return {
      protocol: [{
        label: this.$t('lang.ConfigSetting.Staticaddress'),
        value: "static"
      }, {
        label: this.$t('lang.ConfigSetting.DHCPclient'),
        value: "dhcp"
      }],
      protocolVlue: "dhcp",
      IPv4protocol: [{
        label: "255.255.255.0",
        value: "255.255.255.0"
      }, {
        label: "255.255.0.0",
        value: "255.255.0.0"
      }, {
        label: "255.0.0.0",
        value: "255.0.0.0"
      }, {
        label: this.$t('lang.ConfigSetting.custom'),
        value: "自定义"
      }],
      IPv4protocolValue: "255.255.255.0",
      checked: true,
      data: {},
      WatchData: {
        proto: '',
        dns: '',
        ipaddr: '',
        netmask: '',
        gateway: '',
        hostname: '',
        metric: '',
        macaddr: '',
        mtu: ''
      },
      loading: true,
      error: {
        ipaddr: false,
        gateway: false,
        hostname: false
      },
      // 网络接口基本信息
      networkInfo: {}
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function handler(newValue, oldValue) {
        this.getConfig();
      }
    }
  },
  activated: function activated() {
    var _this = this;

    this.fetchNetworkInfo();
    this.timer = setInterval(function () {
      _this.fetchNetworkInfo();
    }, 10000);
  },
  deactivated: function deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取配置参数
    getConfig: function getConfig() {
      var _this2 = this;

      this.loading = true;
      clearInterval(this.timer);
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "wan",
        config: "network",
        options: [{
          option: "proto"
        }, {
          option: "dns"
        }, {
          option: "ipaddr"
        }, {
          option: "netmask"
        }, {
          option: "gateway"
        }, {
          option: "hostname"
        }, {
          option: "metric"
        }, {
          option: "macaddr"
        }, {
          option: "mtu"
        }]
      }]).then(function (res) {
        _this2.data = res.data.data.mess[0].s_objects[0].options;
        _this2.WatchData = cloneDeep(_this2.data);

        _this2.fetchNetworkInfo();

        _this2.timer = setInterval(function () {
          _this2.fetchNetworkInfo();
        }, 10000);
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message({
          message: _this2.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    // 获取lan接口基本信息
    fetchNetworkInfo: function fetchNetworkInfo() {
      var _this3 = this;

      getNetworkInfo(this.deviceDid, this.deviceSn, ['wan']).then(function (res) {
        _this3.networkInfo = res.data.data.mess.wan;
      });
    },
    //接收SelectInput的改变传过来的值
    GetSelectValue: function GetSelectValue(props) {
      this.data.netmask = props;
    },
    //接收AddInput的改变传过来的值
    GetAddInput: function GetAddInput(props) {
      this.data.dns = props;
    },
    //提交修改
    updateConfig: function updateConfig() {
      var _this4 = this;

      if (this.data.proto === 'static') {
        if (this.error.ipaddr || this.error.gateway) {
          return;
        }
      } else if (this.data.proto === 'dhcp') {
        if (this.error.hostname) {
          return;
        }
      }

      var data = {}; //循环筛选不为空的值，(不为空则未修改无需上传)

      for (var key in this.data) {
        if (this.data[key] !== '') {
          data[key] = this.data[key];
        }
      }

      if (Object.keys(data).length > 0) {
        if (!isEqual(this.WatchData, this.data)) {
          clearInterval(this.timer); //提交修改

          _updateConfig(this.deviceSn, this.deviceDid, [{
            section: "wan",
            config: "network",
            action: 0,
            index: [0],
            server: 'network',
            options: _objectSpread({}, data)
          }]).then(function (res) {
            if (res.data.data.mess === 0) {
              _this4.$message({
                showClose: true,
                message: _this4.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: 'success'
              });

              _this4.getConfig();
            } else {
              _this4.$message({
                showClose: true,
                message: _this4.$t('lang.ConfigSetting.Configurationerror'),
                type: 'warning'
              });

              return;
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('lang.ConfigSetting.Nochangesmade'),
            type: 'warning'
          });
          return;
        }
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Configurationerror'),
          type: 'warning'
        });
        return;
      }
    },
    //ip验证
    ErrorIp: function ErrorIp(props, key) {
      var test = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      var retu = false;

      if (!test.test(props)) {
        this.error[key] = true;
        retu = true;
      }

      if (!props) {
        this.error[key] = false;
        retu = false;
      }

      if (!retu) {
        this.error[key] = false;
      }
    },
    //不为中文验证
    ErrorHost: function ErrorHost(props, key) {
      var test = /^[a-z0-9]+$/i;
      var retu = false;

      if (!test.test(props)) {
        this.error[key] = true;
        retu = true;
      }

      if (!props) {
        this.error[key] = false;
        retu = false;
      }

      if (!retu) {
        this.error[key] = false;
      }
    }
  },
  components: {
    SelectInput: SelectInput,
    AddInput: AddInput,
    networkInfo: networkInfo
  }
};